import { render } from "./optiHistory.vue?vue&type=template&id=6c3053d0"
import script from "./optiHistory.vue?vue&type=script&lang=js"
export * from "./optiHistory.vue?vue&type=script&lang=js"

import "./optiHistory.vue?vue&type=style&index=0&id=6c3053d0&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__